import { ExternalRedirectRoute } from '../Routing/types';
const redirects: ExternalRedirectRoute[] = [
  {
    path: '/contact',
    externalRedirectTo: {
      'en-US': 'https://maxxnationen.zendesk.com/hc/en-us',
      'pl-PL': 'https://maxxnation.zendesk.com/hc/pl',
    },
  },
];

export default redirects;
